// Import Core Components here
import React, { Component } from "react";
import PropTypes from "prop-types";

// Import App depedency here
import { Input, Utils } from "arv-reactcomponents";
import { RegexMethods } from "npmlinks-constants";

class PincodeInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pincode: props.value,
      pincodeInputErrorMsg: "",
      ispincodeInputValid: false,
      pincodeErrorClass: "",
      isValid: "",
    };

    this.onBlur = this.onBlur.bind(this);
    this.validatePincode = this.validatePincode.bind(this);
  }

  componentDidMount() {
    const { pincode } = this.state;
    if (pincode) {
      const e = {
        target: {
          value: pincode,
        },
      };
      this.validatePincode(e);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.pincodeErrMsg) {
      this.setState({
        pincodeErrorClass: "",
      });
    }
  }

  onBlur() {
    let pincodeErrorClass = "nwc-hidden";
    let isValid = "";
    if (!this.state.ispincodeInputValid) {
      pincodeErrorClass = "";
      isValid = "is-invalid";
    }
    this.setState({ pincodeErrorClass, isValid });
    if (this.props.pincodeErrMsg) {
      this.setState({
        pincodeErrorClass: "",
      });
    }
  }

  validatePincode(e) {
    this.setState({ pincodeErrorClass: "nwc-hidden" });
    const validatePincodeNoField = this.validatePincodeFieldRef.getValidatedOutput(
      e.target.value,
    );
    this.setState({
      ispincodeInputValid: validatePincodeNoField.isValid,
      pincodeInputErrorMsg: validatePincodeNoField.errorMsg,
      pincode: validatePincodeNoField.value,
      isValid: "",
    });
    if (this.props.pincodeErrMsg) {
      this.setState({
        pincodeErrorClass: "",
      });
    }
    if (validatePincodeNoField.isValid) {
      this.props.onValid(validatePincodeNoField.value);
    }
    this.props.onChange(validatePincodeNoField);
  }

  render() {
    const {
      pincodeInputErrorMsg,
      pincode,
      pincodeErrorClass,
      isValid,
    } = this.state;
    const {
      className,
      placeholder,
      name,
      pincodeErrMsg,
      maxLength,
    } = this.props;
    return (
      <div>
        <Input
          className={`${className} ${isValid}`}
          maxLength={maxLength}
          name={name}
          onBlur={this.onBlur}
          onChange={this.validatePincode}
          placeholder={placeholder}
          type="tel"
          value={pincode}
          ref={values => {
            this.validatePincodeFieldRef = values;
          }}
          validateWithPattern={RegexMethods.PINCODE_REGEX}
        />
        <div className={`nw-form-err-msg ${pincodeErrorClass}`}>
          {pincodeInputErrorMsg || pincodeErrMsg}
        </div>
      </div>
    );
  }
}

PincodeInput.defaultProps = {
  className: "",
  maxLength: 6,
  onChange: Utils.noop,
  value: "",
  onValid: Utils.noop,
};

PincodeInput.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string,
  maxLength: PropTypes.number,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  pincodeErrMsg: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onValid: PropTypes.func,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: PincodeInput,
  component: PincodeInput,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ReturnComponent/PincodeInput/index.js